import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../i18n";

const Row = ({ label, value }) => (
  <div className="flex flex-col gap-1 border-b border-border py-4 sm:flex-row sm:items-center sm:justify-between">
    <span className="font-mono text-xs uppercase tracking-widest text-ink/50">{label}</span>
    <span className="font-body text-base text-ink">{value}</span>
  </div>
);

export default function InformazioniSocietarie() {
  const { lang } = useLang();
  useEffect(() => {
    window.scrollTo(0, 0);
    const title = lang === "it" ? "Informazioni societarie | BOXLY" : "Company information | BOXLY";
    document.title = title;
  }, [lang]);
  const it = lang === "it";

  return (
    <main className="bg-white pb-24 pt-28 sm:pt-32" data-testid="legal-info-page">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link to="/" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-ink/60 transition-colors hover:text-electric-blue" data-testid="back-home">
          <ArrowLeft className="h-3.5 w-3.5" /> {it ? "Torna alla home" : "Back to home"}
        </Link>
        <h1 className="mt-6 font-display text-4xl font-black leading-[0.95] text-ink sm:text-5xl">
          {it ? "Informazioni societarie" : "Company information"}
        </h1>
        <p className="mt-4 max-w-xl font-body text-base text-ink/70">
          {it
            ? "BOXLY è il brand commerciale di NEWNETWORK S.R.L.S., società titolare del progetto."
            : "BOXLY is the commercial brand of NEWNETWORK S.R.L.S., the company that owns the project."}
        </p>

        <div className="mt-12 rounded-lg border border-border bg-white p-6 sm:p-8">
          <Row label={it ? "Ragione sociale" : "Company name"} value="NEWNETWORK S.R.L.S." />
          <Row label={it ? "Forma giuridica" : "Legal form"} value={it ? "Società a responsabilità limitata semplificata" : "Simplified limited liability company"} />
          <Row label={it ? "Sede legale" : "Registered office"} value="Corso San Giovanni a Teduccio 440, 80146 Napoli (NA), Italia" />
          <Row label="P.IVA / C.F." value="10290721215" />
          <Row label={it ? "Registro Imprese" : "Business Register"} value={it ? "Registro Imprese di Napoli" : "Business Register of Naples"} />
          <Row label="REA" value="NA-1094905" />
          <Row label={it ? "Capitale sociale" : "Share capital"} value={it ? "€ 2.500,00 interamente versato" : "€ 2,500.00 fully paid-in"} />
          <Row label={it ? "Assetto societario" : "Ownership"} value={it ? "Società a socio unico" : "Sole-shareholder company"} />
          <Row label="PEC" value={<a href="mailto:newnetworksrls@pec.it" className="text-electric-blue underline">newnetworksrls@pec.it</a>} />
          <Row label={it ? "Email generale" : "General email"} value={<a href="mailto:info@boxlyitalia.it" className="text-electric-blue underline">info@boxlyitalia.it</a>} />
        </div>

        <p className="mt-10 font-body text-sm text-ink/60">
          {it
            ? "Per ogni comunicazione legale o societaria è preferibile utilizzare l'indirizzo PEC. Per informazioni commerciali è possibile scrivere all'email generale o al contatto commerciale diretto."
            : "For any legal or corporate communication, please use the PEC address. For commercial inquiries you can write to the general email or to the direct commercial contact."}
        </p>
      </div>
    </main>
  );
}
